import { useState } from 'react'
import Navbar from '../../components/Navbar'
import '../../components/styles.css'
// import { useState } from 'react'

export default function BootstrapForm() {
  const [submitting, setIsSubmit] = useState({
    isSubmit: false,
    frmClass: ''
  })
  // const [frm, setFrm] = useState({
  //   date: '',
  //   time: ''
  // })
  // const onChange = (event) => {
  //   let inputs = {}
  //   if (event.target.type === 'date') {
  //     inputs = { date: event.target.value }
  //   } else if (event.target.type === 'time') {
  //     inputs = { time: event.target.value }
  //   }
  //   setFrm({ ...frm, ...inputs })
  // }

  const onSubmit = () => {
    // giả định là false trường
    let inputs = { isSubmit: true, frmClass: 'was-validated' }
    setIsSubmit({ ...submitting, ...inputs })
  }

  return (
    <div>
      <Navbar />
      <main className='container-md main-content'>
        <form className={`g-3 needs-validation ${submitting.frmClass}`} noValidate>
          <h2 className='mb-2'>layout(horizontal, size small, col-auto, validation, nowrap validation, flex-inline)</h2>
          {/* input email */}
          <div>
            <h3>input email</h3>
            <div className='row mb-2'>
              <label htmlFor='input-email' className='col-auto col-form-label col-form-label-sm'>email (*):</label>
              <div className='col-auto'>
                <div className='d-inline-flex align-items-center'>
                  <input type='email' className='form-control form-control-sm' id='input-email' aria-describedby='validation-email-feedback' aria-label='email' required />
                  <div id='validation-email-feedback' className='invalid-feedback m-0 ps-2 text-nowrap'>* email is required</div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          {/* input text */}
          <div>
            <h3>input text</h3>
            <div className='row mb-2'>
              <label htmlFor='input-text' className='col-auto col-form-label col-form-label-sm'>text (*):</label>
              <div className='col-auto'>
                <div className='d-inline-flex align-items-center'>
                  <input type='text' className='form-control form-control-sm' id='input-text' aria-describedby='validation-text-feedback' aria-label='text' required />
                  <div id='validation-text-feedback' className='invalid-feedback m-0 ps-2 text-nowrap'>* text is required</div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          {/* input password */}
          <div>
            <h3>input password</h3>
            <div className='row mb-2'>
              <label htmlFor='input-text' className='col-auto col-form-label col-form-label-sm'>password (*):</label>
              <div className='col-auto'>
                <div className='d-inline-flex align-items-center'>
                  <input type='password' className='form-control form-control-sm' id='input-password' aria-describedby='validation-password-feedback' aria-label='password' required />
                  <div id='validation-password-feedback' className='invalid-feedback m-0 ps-2 text-nowrap'>* password is required</div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          {/* input number */}
          <div>
            <h3>input number</h3>
            <div className='row mb-2'>
              <label htmlFor='input-text' className='col-auto col-form-label col-form-label-sm'>number (*):</label>
              <div className='col-auto'>
                <div className='d-inline-flex align-items-center'>
                  <input type='number' className='form-control form-control-sm' id='input-number' aria-describedby='validation-number-feedback' aria-label='number' min={0} max={100} required />
                  <div id='validation-number-feedback' className='invalid-feedback m-0 ps-2 text-nowrap'>* number is required</div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          {/* input textarea */}
          <div>
            <h3>input textarea (label-no padding top, validation-align start)</h3>
            <div className='row mb-2'>
              <label htmlFor='input-textarea' className='col-auto col-form-label col-form-label-sm pt-0'>textarea (*):</label>
              <div className='col-auto'>
                <div className='d-inline-flex align-items-start'>
                  <textarea className='form-control form-control-sm' id='textarea-input-name' name='textarea-name' rows={2} cols={30} aria-describedby='validation-textarea-feedback' aria-label='textarea' required />
                  <div id='validation-textarea-feedback' className='invalid-feedback m-0 ps-2 text-nowrap'>* textarea is required</div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          {/* input file */}
          <div>
            <h3>input file</h3>
            <div className='row mb-2'>
              <label htmlFor='input-file' className='col-auto col-form-label col-form-label-sm'>file (*):</label>
              <div className='col-auto'>
                <div className='d-inline-flex align-items-center'>
                  <input type='file' className='form-control form-control-sm' id='input-file' aria-describedby='validation-file-feedback' aria-label='file' required />
                  <div id='validation-file-feedback' className='invalid-feedback m-0 ps-2 text-nowrap'>* file is required</div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          {/* checkbox */}
          <div>
            <h3>checkbox (group with form-check, right-text)</h3>
            <div className='row mb-2'>
              <div className='col-auto'>
                <div className='d-inline-flex flex-column'>
                  <div className='d-flex align-items-center form-check mb-0'>
                    <input type='checkbox' className='form-check-input mt-0' id='input-checkbox' aria-describedby='validation-checkbox-feedback' aria-label='checkbox' required />
                    <label htmlFor='input-checkbox' className='col-form-label col-form-label-sm form-check-label ps-1 text-nowrap'>checkbox (*):</label>
                    <div id='validation-checkbox-feedback' className='invalid-feedback m-0 ps-2 text-nowrap'>* checkbox is required</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          {/* radio */}
          <div>
            <h3>radio</h3>
            <div className='row mb-2'>
              <div className='col-auto'>
                <div className='d-inline-flex flex-column'>
                  <div className='d-flex align-items-center form-check mb-0'>
                    <input className='form-check-input mt-0' type='radio' name='flexRadioDefault' id='flex-radio-default-1' aria-describedby='validation-checkbox-feedback' aria-label='radio 1' required/>
                    <label htmlFor='flex-radio-default-1' className='col-form-label col-form-label-sm form-check-label ps-1 text-nowrap'>radio 1 (*)</label>
                  </div>
                  <div className='d-flex align-items-center form-check mb-0'>
                    <input className='form-check-input mt-0' type='radio' name='flexRadioDefault' id='flex-radio-default-2' aria-describedby='validation-checkbox-feedback' aria-label='radio 2' required/>
                    <label htmlFor='flex-radio-default-1' className='col-form-label col-form-label-sm form-check-label ps-1 text-nowrap'>radio 2 (*)</label>
                    <div id='validation-radio-feedback' className='invalid-feedback m-0 ps-2 text-nowrap'>* radio is required</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          {/* input date time */}
          <div>
            <h3>input datetime</h3>
            <div className='row mb-2'>
              <label htmlFor='input-text' className='col-auto col-form-label col-form-label-sm'>datetime (*):</label>
              <div className='col-auto'>
                <div className='d-inline-flex align-items-center'>
                    <input type='date' className='form-control form-control-sm me-1' id='date-input-name' name='date-name' aria-describedby='validation-date-feedback' aria-label='date' required />
                    <input type='time' className='form-control form-control-sm ms-1' id='time-input-name' name='time-name' aria-label='time' />
                    <div id='validation-date-feedback' className='invalid-feedback m-0 ps-2 text-nowrap'>* date is required</div>
                </div>
              </div>
            </div>
          </div>
          <hr />

          {/* select option */}
          <div>
            <h3>select option </h3>
            <div className='row mb-2'>
              <label htmlFor='input-file' className='col-auto col-form-label col-form-label-sm'>select option (*):</label>
              <div className='col-auto'>
                <div className='d-inline-flex align-items-center'>
                  <select className='form-select form-select-sm text-nowrap' required aria-label='select option'>
                    <option value=''>Choose one</option>
                    <option value='1'>One</option>
                    <option value='2'>Two</option>
                    <option value='3'>Three</option>
                  </select>
                  <div id='validation-select-feedback' className='invalid-feedback m-0 ps-2 text-nowrap'>* select is required</div>
                </div>
              </div>
            </div>
          </div>
          <hr />



          {/* button */}
          <div>
            <h3>button</h3>
            <div className='d-flex flex-column align-items-start g-3'>
              <button type='submit' onClick={onSubmit}>submit</button>
            </div>
          </div>
          <hr />

          {/* table */}
          <div>
            <h3>table (small, small responsive, border, caption, head-body) </h3>
            <div className='d-flex flex-column align-items-start g-3'>
              <table className='table table-sm table-responsive-sm table-bordered'>
                <caption className='caption-top'>List of users</caption>
                <thead>
                  <tr>
                    <th scope='col'>#</th>
                    <th scope='col'>First</th>
                    <th scope='col'>Last</th>
                    <th scope='col'>Handle</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope='row'>1</th>
                    <td>Mark</td>
                    <td>Otto</td>
                    <td>@mdo</td>
                  </tr>
                  <tr>
                    <th scope='row'>2</th>
                    <td>Jacob</td>
                    <td>Thornton</td>
                    <td>@fat</td>
                  </tr>
                  <tr>
                    <th scope='row'>3</th>
                    <td colSpan={2}>Larry the Bird</td>
                    <td>@twitter</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <hr />
        </form>
      </main>
    </div>
  )
}
